import {
  ITransferPendenciesTraysResponse,
  ITrayInfoItem,
} from '../../../types';

/**
 * This function formats the response for transfer pendencies trays.
 * It extracts the trays and total count from the response data,
 * and formats each tray item to include a missing tray label.
 */
export function formatTransferPendenciesTraysResponse(
  response: ITransferPendenciesTraysResponse
): ITrayInfoItem[] {
  return response.data.map((tray) => ({
    trayId: tray.trayId,
    trayNumber: tray.trayNumber,
    appraisalCount: tray.totalInventories,
  }));
}
